export type CaptureWindow = {
  started_at: string;
  finished_at: string;
  timezone: string;
  basis: "recorder_process";
};

export function recordingWindowLabel(window?: CaptureWindow | null) {
  if (!window) return null;
  const start = new Date(window.started_at);
  const end = new Date(window.finished_at);
  if (!Number.isFinite(+start) || !Number.isFinite(+end) || end <= start)
    return null;
  try {
    const date = new Intl.DateTimeFormat("en-US", {
      timeZone: window.timezone,
      month: "short",
      day: "numeric",
      year: "numeric",
    });
    const time = new Intl.DateTimeFormat("en-US", {
      timeZone: window.timezone,
      hour: "numeric",
      minute: "2-digit",
      second: "2-digit",
      timeZoneName: "short",
    });
    const endDate =
      date.format(start) === date.format(end) ? "" : `${date.format(end)} · `;
    return `${date.format(start)} · ${time.format(start)} – ${endDate}${time.format(end)}`;
  } catch {
    return null;
  }
}
